import { GetStaticProps } from "next";
import { getLanguageStaticProps } from "../src/helper/languageHelper";
import PrivacyPolicyFaqComponent from "../src/pages/PrivacyPolicyFaqComponent";

interface PrivacyPolicyProps {}

const PrivacyPolicyFaq: React.FC<PrivacyPolicyProps> = () => {
  return ( <PrivacyPolicyFaqComponent /> );
};

export const getStaticProps: GetStaticProps = (context) => {
  return getLanguageStaticProps(context);
};

export default PrivacyPolicyFaq;
